<div class="cardSolution">
  <div
    class="contentImage cardImage"
    (click)="goTo(solution().slug)"
    aria-hidden="true"
  >
    @if(solution().listImage && solution().listImage.id !== 0) {
    <img
      [ngSrc]="solution().listImage.image"
      [alt]="solution().listImage.alt"
      fill
    />
    }@else {
    <img ngSrc="/general/no-image.jpg" alt="no image" fill />
    }
  </div>
  <a
    [routerLink]="`/soluciones-digitales/${solution().slug}`"
    class="cardTitle"
  >
    <h3>{{ solution().name | uppercase }}</h3>
  </a>
  <p class="content" (click)="goTo(solution().slug)" aria-hidden="true">
    {{ solution().shortDescription }}
  </p>
  @if (showApps()) {
  <div class="links">
    @if (solution().iosLink !== '' && solution().iosLink !== 'no') {
    <a
      [href]="solution().iosLink"
      target="_blank"
      rel="noopener noreferrer"
      class="external"
    >
      <div class="contentImage">
        <img
          ngSrc="/solutions/icon-app-store.webp"
          alt="icono app store"
          fill
        />
      </div> </a
    >}@if (solution().androidLink !== '' && solution().androidLink !== 'no') {
    <a
      [href]="solution().androidLink"
      target="_blank"
      rel="noopener noreferrer"
      class="external"
    >
      <div class="contentImage">
        <img
          ngSrc="/solutions/icon-google-play.webp"
          alt="icono play store"
          fill
        /></div
    ></a>
    }
  </div>
  }
  <button class="btnTracsa btnPrimary" (click)="goTo(solution().slug)">
    CONOCER SOLUCIÓN
  </button>
</div>
